__turbopack_context__.v({
  "accordion": "JumpMenu-module-scss-module__BPfeiq__accordion",
  "accordionControl": "JumpMenu-module-scss-module__BPfeiq__accordionControl",
  "linkItem": "JumpMenu-module-scss-module__BPfeiq__linkItem",
  "linkList": "JumpMenu-module-scss-module__BPfeiq__linkList",
  "section": "JumpMenu-module-scss-module__BPfeiq__section",
});
